import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telephone: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    subject: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    notes: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone',
            mapping: 'telephone',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated Guest Count',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Subject...',
            options: [
              { label: 'Wedding Inquiry', value: 'Wedding Inquiry'},
              { label: 'Corporate Inquiry', value: 'Corporate Inquiry' },
              { label: 'Private/Social Event Inquiry', value: 'Private/Social Event Inquiry' },
              { label: 'Drop Off/Pickup Inquiry', value: 'Drop Off/Pickup Inquiry' },
              { label: 'General Inquiry', value: 'General Inquiry' },
              { label: 'Venue Inquiry', value: 'Venue Event Inquiry' }
            ],
            mapping: 'subject',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Your Message',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Send'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Daniel Et Daniel Contact Form',
    formId: '171',
    clientKey: '3907878A-6653-415E-9760-522CD42AE1BE',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '//www.caterease.com/throwthat404likecraycray',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/danieletdanielclone/form_structure.js